import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Text } from '@stashinvest/ui/dist/es/2';
import { getFormattedDateString, parseDate } from 'stash/utils';

const CalendaryDayWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: ${({ theme }) => theme.space.s16};
	width: 54px;
	height: 54px;
	border: 2px solid ${({ theme }) => theme.colors.borderDefault};
	border-radius: ${({ theme }) => theme.borderRadius.radius8};
	background-color: ${({ theme }) => theme.colors.bgPrimary};
	text-align: center;
`;

const CalendarDay = ({ date, status }) => {
	const month = date ? getFormattedDateString(parseDate(date), `MMM`) : null;
	const day = date ? getFormattedDateString(parseDate(date), `d`) : null;

	return (
		<CalendaryDayWrapper>
			{month && day ? (
				<div>
					<Text.Body12 color={status ? 'textTertiary' : 'textDisabled'}>
						{month}
					</Text.Body12>
					<Text.Body16
						color={status ? 'textTertiary' : 'textDisabled'}
						fontWeight="medium"
					>
						{day}
					</Text.Body16>
				</div>
			) : (
				<div>
					<Text.Body16 color="textDisabled" fontWeight="medium">
						-
					</Text.Body16>
				</div>
			)}
		</CalendaryDayWrapper>
	);
};
CalendarDay.propTypes = {
	date: PropTypes.string,
	status: PropTypes.bool,
};
export default CalendarDay;
